import React from 'react';

import { Alert, Button, Flex, Group, Modal, Space, Text, Title } from '@mantine/core';
import { IconAlertTriangle, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface DeleteContentModalProps {
  isModalOpened: boolean;
  withCloseButton: boolean;
  description: string;
  alertTitle: string;
  alertDescription: string;
  title?: string;
  loading?: boolean;
  onConfirm: () => void;
  cancelAction: () => void;
}

export function DeleteContentModal({
  isModalOpened,
  description,
  alertTitle,
  alertDescription,
  withCloseButton,
  title,
  loading,
  onConfirm,
  cancelAction
}: DeleteContentModalProps) {
  const { t } = useTranslation();

  return (
    <Modal title={title} withCloseButton={withCloseButton} opened={isModalOpened} onClose={cancelAction}>
      <Flex display="flex" justify="center" align="center" direction="column">
        <Title order={4} align="center">
          {description}
        </Title>
        <Space h="xs" />
        <Alert sx={{ width: '70%' }} icon={<IconAlertTriangle></IconAlertTriangle>} title={alertTitle} color="red">
          <Text color="red">{alertDescription}</Text>
        </Alert>

        <Space h="lg" />

        <Group position="left">
          <Button
            color="gray"
            variant="outline"
            onClick={() => {
              cancelAction();
            }}>
            {t('APP.ACTIONS.BACK')}
          </Button>
          <Button
            variant="outline"
            color="red"
            loading={loading}
            rightIcon={<IconTrash />}
            onClick={(event) => {
              event.stopPropagation();
              return onConfirm();
            }}>
            {t('APP.ACTIONS.DELETE')}
          </Button>
        </Group>
      </Flex>
    </Modal>
  );
}
